import CustomText from "@components/CustomText";
import DashedLine from "@components/DashedLine";
import IssueTags from "@components/IssueTags";
import color from "@constants/color";
import { meta } from "@constants/cplp";
import React from "react";
import { View } from "react-native";

const PaymentAndIssueTags = ({ payment }) => {
  const paymentModeLabel =
    payment.payment_status === "COD" ? meta.cod_label : meta.online_label;
  const paymentAmount = payment.amount;
  const cashOrRefundLabel =
    payment.payment_status === "COD"
      ? meta.cod_refund_label
      : meta.online_refund_label;
  const cashOrRefundAmount =
    !!payment.disputed_amount && payment.payment_status === "COD"
      ? payment?.cx_to_pay_cp_amount
      : payment?.direct_refund_to_cx_amount;
  return payment ? (
    <View>
      <DashedLine
        axis="horizontal"
        height="120"
        spacing="4"
        dashHeight="1"
        dashColor={color.lighterBlack}
        dashWidth="2"
      />
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          paddingHorizontal: 16,
          paddingTop: 16,
          alignItems: "center",
        }}
      >
        <View style={{ flexDirection: "row" }}>
          <CustomText
            variant="body_text_4"
            style={{ color: "rgba(0, 0, 0, 0.56)", fontWeight: "600" }}
          >
            {`${meta.payment_mode}`}
          </CustomText>
          <CustomText
            variant="body_text_3"
            style={{
              color:
                payment.payment_status === "COD"
                  ? "rgba(0, 171, 89, 1)"
                  : "rgba(0, 0, 0, 0.56)",
            }}
          >
            {` (${paymentModeLabel})`}
          </CustomText>
        </View>
        <CustomText variant="title_16" style={{ color: color.mediumBlack }}>
          {`₹${paymentAmount}`}
        </CustomText>
      </View>
      {payment.disputed_amount ? (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            paddingHorizontal: 16,
            paddingTop: 8,
            alignItems: "center",
          }}
        >
          <CustomText variant="body_text_4" style={{ color: color.black }}>
            {meta.raised_issue_label}
          </CustomText>
          <CustomText
            variant="body_text_4"
            style={{ color: color.mediumBlack }}
          >
            {`${payment.disputed_amount}`}
          </CustomText>
        </View>
      ) : null}
      <View
        style={{
          flexDirection: "row",
          paddingHorizontal: 16,
          paddingBottom: 16,
        }}
      >
        <IssueTags current_state={payment.disputed_tags} />
      </View>
      <DashedLine
        axis="horizontal"
        height="120"
        spacing="5"
        dashHeight="1"
        dashColor="rgba(244, 244, 244, 1)"
        dashWidth="05"
      />
      {payment.disputed_amount ? (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            paddingHorizontal: 16,
            paddingBottom: 12,
            paddingTop: 16,
            alignItems: "center",
          }}
        >
          <CustomText variant="body_text_4" style={{ color: color.black }}>
            {cashOrRefundLabel}
          </CustomText>
          <CustomText variant="title_16" style={{ color: color.mediumBlack }}>
            {`₹${cashOrRefundAmount}`}
          </CustomText>
        </View>
      ) : null}
    </View>
  ) : null;
};

export default PaymentAndIssueTags;
